import classes from "./BooksSummary.module.css";

const BooksSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Explore Treasured Reads, Delivered to Your Doorstep</h2>
      <p>
        Select your next great adventure from our expansive collection of
        secondhand books and enjoy the luxury of a quiet evening lost in a
        classic tale or a thrilling narrative.
      </p>
    </section>
  );
};

export default BooksSummary;
